/**
 * Supabase 클라이언트 설정 (선택적)
 * - Supabase를 사용하지 않는 경우 null 반환
 * - 자체 인증 시스템으로 전환됨 (2026-01)
 */
import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

/**
 * Supabase 클라이언트 (선택적)
 * - URL과 키가 없으면 null 반환
 * - Supabase 미사용 시에도 앱이 정상 동작
 */
export const supabase: SupabaseClient | null = (supabaseUrl && supabaseAnonKey)
  ? createClient(supabaseUrl, supabaseAnonKey, {
      realtime: {
        params: {
          eventsPerSecond: 10,
        },
      },
    })
  : null;

/**
 * Realtime 사용 여부 확인 (캐싱)
 * - Supabase가 설정되어 있고 명시적으로 비활성화하지 않은 경우에만 true
 */
let _realtimeEnabledCache: boolean | null = null;

export const isRealtimeEnabled = (): boolean => {
  if (_realtimeEnabledCache !== null) {
    return _realtimeEnabledCache;
  }

  // 명시적으로 비활성화된 경우
  if (process.env.REACT_APP_USE_REALTIME === 'false') {
    _realtimeEnabledCache = false;
    return false;
  }

  // Supabase 클라이언트가 없으면 비활성화
  _realtimeEnabledCache = supabase !== null;
  return _realtimeEnabledCache;
};
